import React from "react";
import DashboardShell from "../../components/DashboardShell";
import { useAuth } from "../../lib/auth";

export default function Settings() {
  const { user } = useAuth();
  return (
    <DashboardShell title="Settings" subtitle="Tenant, team, and API keys.">
      <div className="grid md:grid-cols-2 gap-4 max-w-4xl">
        <div className="rounded-xl bg-white/5 border border-white/10 p-5">
          <div className="eyebrow text-[#FFD98A] mb-3" style={{fontSize:10}}>TENANT</div>
          {[
            ["Name", user?.name],
            ["Email", user?.email],
            ["Tier", user?.tier],
            ["Tenant ID", user?.tenant_id],
            ["Created", user?.created_at && new Date(user.created_at).toLocaleString()],
          ].map(([k,v]) => (
            <div key={k} className="flex justify-between py-2 border-b border-white/5 last:border-0 text-sm">
              <span className="text-cream/50">{k}</span>
              <span className="font-mono text-cream/85">{v}</span>
            </div>
          ))}
        </div>
        <div className="rounded-xl bg-white/5 border border-white/10 p-5">
          <div className="eyebrow text-[#FFD98A] mb-3" style={{fontSize:10}}>API KEY</div>
          <div className="font-mono text-xs text-cream/70 break-all bg-black/30 p-3 rounded-lg border border-white/5">
            {localStorage.getItem("sentry_token")?.slice(0, 80)}…
          </div>
          <p className="text-xs text-cream/50 mt-3">Use this bearer token for all Gateway and Admin API calls.</p>
        </div>
      </div>
    </DashboardShell>
  );
}
